<script setup lang="ts">
import { computed } from 'vue';
import FormRow from '@/components/Common/FormRow.vue';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import i18n from '@/lang/i18n';

const props = defineProps<{
  modelValue: string;
  errorMessages?: string[];
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const hours = Array.from({ length: 25 }, (_, i) => ({
  title: String(i).padStart(2, '0'),
  value: String(i).padStart(2, '0'),
}));

const minutes = [
  { title: '00', value: '00' },
  { title: '30', value: '30' },
];

const hour = computed({
  get: () => props.modelValue.split(':')[0] ?? '00',
  set: (val) => emit('update:modelValue', `${val}:${props.modelValue.split(':')[1] ?? '00'}`),
})

const minute = computed({
  get: () => props.modelValue.split(':')[1] ?? '00',
  set: (val) => emit('update:modelValue', `${props.modelValue.split(':')[0] ?? '00'}:${val}`),
})
</script>

<template>
  <FormRow
    :title="i18n.global.t('pages.gpsTrackerSetting.tripStartTime')"
    :required="true"
  >
    <div class="d-flex align-center gap-2">
      <v-select
        v-model="hour"
        :items="hours"
        item-title="title"
        item-value="value"
        hide-details
        :clearable="false"
        style="max-width: 100px"
      />
      <span class="mx-1">:</span>
      <v-select
        v-model="minute"
        :items="minutes"
        item-title="title"
        item-value="value"
        hide-details
        :clearable="false"
        style="max-width: 100px"
      />
    </div>
    <ValidationErrors :messages="errorMessages" />
  </FormRow>
</template>
